import _ from 'lodash';
import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import FormActions from './form-actions';

const initialState = Immutable({
  byId:                 {},
  isFetching:           false,

  //props for saving a form
  isSaving:        false,
  isSaveSuccess:   false,
  isSaveError:     false,
});

const reducer = createReducer(on => {
  on([FormActions.fetchExperienceForm, FormActions.fetchContainerForms, FormActions.fetchLibraryForms], state => {
    return state.set('isFetching', true);
  });
  on(FormActions.fetchFormsFailure, state => {
    return state.set('isFetching', false);
  });
  on(FormActions.fetchFormsSuccess, (state, { forms }) => {
    const byId = _.reduce(
      forms,
      (acc, form) => {
        acc[form.id] = form;
        return acc;
      },
      {}
    );
    return state.merge({ isFetching: false, byId });
  });
  //adds a form config to the forms byId object
  on(FormActions.addFormConfig, (state, { form }) => {
    return state.merge(
      {
        byId: {
          [form.id]: form
        },
      },
      { deep: true }
    )
  });

  on(FormActions.saveForms, state => state.set('isSaving', true));
  on(FormActions.saveFormsSuccess, state => state.merge({ isSaving: false, isSaveSuccess: true }));
  on(FormActions.saveFormsFailure, state => state.merge({ isSaving: false, isSaveError: true }));
  on(FormActions.finishSaving, state => state.merge({ isSaving: false, isSaveSuccess: false, isSaveError: false }));
  on(FormActions.receiveUpdatedForm, (state, { form }) => {
    const updatedForm = {
      byId: {
        [form.id]: form,
      },
    };
    return state.merge(updatedForm, { deep: true });
  });
}, initialState);

export default reducer;
